@if (paths && paths.length) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @for (path of paths; track path; let isLast = $last) {
        @if (!isLast) {
          <li class="breadcrumb-item"><a [routerLink]="path.path">{{path.name}}</a></li>
        }
        @if (isLast) {
          <li class="breadcrumb-item active" aria-current="page">{{path.name}}</li>
        }
      }
    </ol>
  </nav>
}